import { FETCH_SUBSITES } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_SUBSITES:
			return action.payload;
		default:
			return state;
	}
};
